import { ReactNode } from 'react';
import { Wrapper } from './styles';

interface PopoverProps {
  content: ReactNode;
  children: ReactNode;
  visible: boolean;
  position: 'left' | 'right';
}

export const Popover = ({
  content,
  children,
  visible,
  position,
}: PopoverProps) => {
  return (
    <Wrapper position={position}>
      {children}
      {visible && <div className="input-wrapper">{content}</div>}
    </Wrapper>
  );
};
